import React, { useEffect } from 'react';
import Chart from 'chart.js/auto';

interface BarGraphProps {
  chartData: {
    labels: string[];
    datasets: Array<{
      label: string;
      data: number[];
      backgroundColor?: string | string[];
      stack?: string;
    }>;
  };
  uuid: string;
  height?: number;
  stacked?: boolean;
}

const BarGraph: React.FC<BarGraphProps> = ({ chartData, uuid, height = 220, stacked = false }) => {
  const id = uuid || 'bar-chart';

  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    const ctx = (el as HTMLCanvasElement).getContext('2d');
    if (!ctx) return;

    const chartInstance = new Chart(ctx, {
      type: 'bar',
      data: chartData,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: { position: 'bottom' },
        },
        scales: {
          x: {
            stacked,
            ticks: { autoSkip: true, maxTicksLimit: 14 },
          },
          y: {
            stacked,
            beginAtZero: true,
            ticks: { precision: 0 },
          },
        },
      },
    });

    return () => {
      chartInstance.destroy();
    };
  }, [chartData, id, stacked]);

  return (
    <div style={{ height, position: 'relative' }}>
      <canvas id={id} />
    </div>
  );
};

export default BarGraph;
